import { FieldControlValue } from "./types";

// Legacy rows written by the Dreamer autofill store boolean-style answers as
// quoted strings ("Yes", "No", "checked") instead of a JSON boolean. Mirrors
// the vocabulary SCOFieldsUtils.normalize_bool_response_value accepts
// server-side so a pre-existing row renders the same answer the score (or
// checkbox state) was computed from.
export const POSITIVE_BOOL_TOKENS = new Set(["true", "yes", "checked"]);
export const NEGATIVE_BOOL_TOKENS = new Set(["false", "no", "unchecked"]);

// Checkboxes are stored as "checked" / "unchecked" on deal questionnaires,
// but legacy Dreamer-autofill rows use the broader vocabulary above.
export const decodeCheckbox = (stored: unknown): boolean => {
  if (stored === true) return true;
  if (typeof stored === "string") {
    return POSITIVE_BOOL_TOKENS.has(stored.trim().toLowerCase());
  }
  return false;
};
export const encodeCheckbox = (value: FieldControlValue) =>
  value === true ? "checked" : "unchecked";
